import React from "react";
import Login from "../pages/login";
import Dashboard from "../pages/dashboard";
import Page from "@jumbo/shared/Page";
import MenuPermissionsManager from "app/pages/menuPermission/menuPermission";
import AddUser from "app/pages/addUser/addUser";
import Menu from "app/pages/menu/menu";
import Branch from "app/pages/branch";
import Role from "app/pages/role";
import Company from "app/pages/company/Company";
import params from "app/pages/params";
import polishInward from "app/pages/polishInward";
import Inventory from "app/pages/Inventory";
import Party from "app/pages/party/Party";
import GlobleParams from "app/pages/globleParams";
import Discountmap from "app/pages/discountmap/Discountmap";
import Basket from "app/pages/basket";
import AllTransaction from "app/pages/allTransaction";
import Synonymsmaster from "app/pages/synonymsmaster";
import Error404 from "app/pages/Error404";
import Country from "app/pages/country";
import Statemas from "app/pages/statemas";
import ManageRapaport from "app/pages/ManageRapaport";
import citymas from "app/pages/citymas";
import groupHead from "app/pages/groupHead";
import accHead from "app/pages/accHead";
import ledgerMas from "app/pages/ledgerMas";
import lotCreation from "app/pages/lotCreation";
import bulkagrdisc from "app/pages/bulkagrdisc";
import UserRegister from "app/pages/login/userRegister";
import userSearch from "app/pages/userSearch";
import userbasket from "app/pages/userbasket";
import perfomaGenrate from "app/pages/perfomaGenrate";
import packetGenerate from "app/pages/packetGenerate";
import paymentreceive from "app/pages/paymentreceive";
import partyPayment from "app/pages/partyPayment";
import expenseBill from "app/pages/expenseBill";
import accTxn from "app/pages/accTxn";
import acctxnHistory from "app/pages/acctxnHistory";
import ReportPurchaseSalesRegister from "app/pages/reportPurchaseSalesRegister";
import reportPurchaseOrSalesOutstanding from "app/pages/reportPurchaseOrSalesOutstanding";
import reportGeneralLedger from "app/pages/generalLedger";
import reportBankBalance from "app/pages/bankBalance";
import reportAdvanceOutstanding from "app/pages/advanceOutstandingReport";
import finYears from "app/pages/finYears/finYears";
import memoInRC from "app/pages/memoInRC";
import PartyTransactionDetail from "app/pages/partyTransactionDetail/partyTransactionDetail";
import partStoneStatus from "app/pages/partStoneStatus";
import singleStockCount from "app/pages/singleStockCount";
import BulkProcess from "app/pages/bulksale/bulksale";
import stonehistory from "app/pages/stonehistory";
import lotUpdate from "app/pages/lotUpdate";

/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/
const routesForPublic = [
  {
    path: "*",
    element: <Page component={Error404} layout={"solo-page"} />,
  },
];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
  {
    path: "/",
    name: "Home",
    element: <Page component={Dashboard} />,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    element: <Page component={Dashboard} />,
  },
  {
    path: "/menuPermission",
    name: "menuPermission",
    element: <Page component={MenuPermissionsManager} />,
  },
  {
    path: "/users",
    name: "users",
    element: <Page component={AddUser} />,
  },
  // {
  //     path: "/salesperson",
  //     name:'salesperson',
  //     element: <Page component={salesperson} />
  // },
  {
    path: "/role",
    name: "/role",
    element: <Page component={Role} />,
  },
  {
    path: "/menu",
    name: "/menu",
    element: <Page component={Menu} />,
  },
  {
    path: "/company",
    name: "/company",
    element: <Page component={Company} />,
  },
  {
    path: "/params",
    name: "/params",
    element: <Page component={params} />,
  },
  {
    path: "/globleParams",
    name: "/globleParams",
    element: <Page component={GlobleParams} />,
  },
  {
    path: "/synonymsmaster",
    name: "/synonymsmaster",
    element: <Page component={Synonymsmaster} />,
  },
  {
    path: "/stonehistory",
    // name: "/bulk/disc",
    exact: true,
    element: <Page component={stonehistory} />,
  },
  {
    path: "/branch",
    name: "/branch",
    element: <Page component={Branch} />,
  },
  {
    path: "/inventory",
    name: "/inventory",
    element: <Page component={Inventory} />,
  },
  {
    path: "/lotupdate",
    exact: true,
    element: <Page component={lotUpdate} modulecode={'LotUpdate'}/>,
  },
  {
    path: "/searchcriteria",
    name: "/searchcriteria",
    element: <Page component={userSearch} />,
  },
  // {
  //     path: "/search-result/",
  //     element: <Page component={searchResult} />
  // },
  // {
  //     path: "/search-result/:searchid",
  //     name: "/search-result",
  //     element: <Page component={searchResult} />
  // },
  {
    path: "/party",
    name: "/party",
    element: <Page component={Party} />,
  },
  {
    path: "/polishInward",
    name: "/polishInward",
    element: <Page component={polishInward} />,
  },
  {
    path: "/discountmap",
    name: "/discountmap",
    element: <Page component={Discountmap} />,
  },
  {
    path: "/allTransaction",
    name: "/allTransaction",
    element: <Page component={AllTransaction} />,
  },
  {
    path: "/outward",
    name: "/outward",
    exact: true,
    element: <Page component={partStoneStatus} />,
  },
  {
    path: "/outward/:type/:prid/:trid",
    name: "/outwardDetail",
    exact: true,
    element: <Page component={PartyTransactionDetail} />,
  },
  {
    path: "/packetGenerate",
    exact: true,
    element: <Page component={packetGenerate} />,
  },
  {
    path: "/mybasket",
    name: "/mybasket",
    element: <Page component={Basket} />,
  },
  {
    path: "/basket",
    name: "/basket",
    element: <Page component={userbasket} />,
  },
  {
    path: "/perfomagenrate",
    element: <Page component={perfomaGenrate} />,
  },
  {
    path: "/countrymas",
    name: "/countrymas",
    element: <Page component={Country} />,
  },
  {
    path: "/managerapaport",
    name: "/managerapaport",
    element: <Page component={ManageRapaport} />,
  },
  {
    path: "/statemas",
    name: "/statemas",
    element: <Page component={Statemas} />,
  },
  {
    path: "/citymas",
    name: "/citymas",
    element: <Page component={citymas} />,
  },
  {
    path: "/acc",
    name: "/acc",
    exact: true,
    element: <Page component={accTxn} />,
  },
  {
    path: "/report/singleStockCount",
    element: <Page component={singleStockCount} />,
  },
  {
    path: "/bulksale/:type/:no",
    name: "bulksale",
    element: <Page component={BulkProcess} />,
  },
  {
    path: "/acc/groupHead",
    name: "/acc/groupHead",
    exact: true,
    element: <Page component={groupHead} />,
  },
  {
    path: "/acc/accHead",
    name: "/acc/accHead",
    exact: true,
    element: <Page component={accHead} />,
  },
  {
    path: "/acc/ledgerMas",
    name: "/acc/ledgerMas",
    exact: true,
    element: <Page component={ledgerMas} />,
  },
  {
    path: "/acc/goodstransaction",
    name: "/goodstransaction",
    exact: true,
    element: <Page component={acctxnHistory} />,
  },
  {
    path: "/acc/paymentreceive",
    exact: true,
    element: <Page component={paymentreceive} />,
  },
  {
    path: "/acc/paymentreceive/:RTYPE/:RID",
    exact: true,
    element: <Page component={paymentreceive} />,
  },
  {
    path: "/acc/partyPayment",
    exact: true,
    element: <Page component={partyPayment} />,
  },
  {
    path: "/acc/partyPayment/:PTYPE/:PID",
    exact: true,
    element: <Page component={partyPayment} />,
  },
  {
    path: "/acc/expensebill",
    exact: true,
    element: <Page component={expenseBill} />,
  },
  {
    path: "/acc/expensebill/:ETYPE/:TRTYPE/:billID",
    exact: true,
    element: <Page component={expenseBill} />,
  },
  {
    path: "/bulk/lotcreation",
    name: "/bulk/lotcreation",
    exact: true,
    element: <Page component={lotCreation} />,
  },
  {
    path: "/bulk/disc",
    name: "/bulk/disc",
    exact: true,
    element: <Page component={bulkagrdisc} />,
  },
  {
    path: "/report/purchasesalesregister",
    element: <Page component={ReportPurchaseSalesRegister} />,
  },
  {
    path: "/report/purchasesalesoutstanding",
    element: <Page component={reportPurchaseOrSalesOutstanding} />,
  },
  {
    path: "/report/reportGeneralLedger",
    element: <Page component={reportGeneralLedger} />,
  },
  {
    path: "/report/reportBankBalance",
    element: <Page component={reportBankBalance} />,
  },
  {
    path: "/report/reportAdvanceOutstanding",
    element: <Page component={reportAdvanceOutstanding} />,
  },
  {
    path: "/master/finYear",
    element: <Page component={finYears} />,
  },{
        path: "/acc/memoinrc",
        exact:true,
        element: <Page component={memoInRC} />
    }
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  {
    path: "/login",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "/user-register",
    element: <Page component={UserRegister} layout={"solo-page"} />,
  },
];

const routes = [
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
  ...routesForPublic,
];

export {
  routes as default,
  routesForPublic,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
